/**
 * User: WangMeng
 * Date: 2018-04-16
 * Time: 9:46
 * Desc: 监管动态搜索
 */

import commonStyles  from '../../common/common.scss';
import style from './search.scss';
import React, { PureComponent } from 'react';
import { Form, Select, Tabs } from 'antd';
import { debounce } from '../../../../../utils/debounce';
import cns from 'classnames';
const FormItem = Form.Item;
const Option = Select.Option;
const TabPane = Tabs.TabPane;

class SearchForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            options: {},
            tagData: ['全部', '年报', '半年报', '三季报', '一季报', '业绩预告', '权益分配', '董事会', '监事会', 
                '股东大会', '日常经营', '公司治理', '中介报告', '首发', '增发', '股权激励', '配股', '解禁', '债券',
                '其他融资', '股权变动', '股改', '权证', '补充更正', '澄清致歉', '风险提示', '特别处理和退市'
            ],
            noticeType: ''
        };
    }

    componentDidMount() {
        this.setOptions();
    }

    componentWillReceiveProps(nextProps) {
        this.setOptions(nextProps);
    }

    componentWillUnmount() {
        this.syncSearch.cancel();
    }

    syncSearch = debounce(() => {
        this.onSubmit();
    }, 300);

    setOptions = (props = this.props) => {
        const { options, onFail } = props;
        if (!this.initialized && (options || options === false)) {
            this.initialized = true;
            if (options) {
                this.setState({
                    options
                }, () => {
                    this.onSubmit();
                });
            } else { // option请求失败
                onFail && onFail();
            }
        }
    };

    onSubmit = (e) => {
        e && e.preventDefault();
        const { onSearch } = this.props;
        const { validateFields } = this.props.form;
        validateFields({ force: true }, (err, values) => {
            if (!err) {
                onSearch && onSearch(values.noticeType === '全部' ? {dateType: values.dateType} : values);
            }
        });
    };

    handleChange = debounce(() => {
        this.onSubmit();
    }, 300);

    render() {
        const { getFieldDecorator } = this.props.form;
        const { tagData } = this.state;
        return (
            <div className={cns('search-bar', commonStyles.searchBar)}>
                <Form hideRequiredMark layout="inline" onSubmit={this.onSubmit}>
                    <FormItem>
                        {getFieldDecorator('dateType', {
                            initialValue: '1'
                        })(
                            <Select size="default" onChange={this.syncSearch}>
                                <Option value="1">近三天</Option>
                                <Option value="2">近一周</Option>
                                <Option value="3">近半个月</Option>
                            </Select>
                        )}
                    </FormItem>
                    <FormItem>
                        {getFieldDecorator('noticeType', {
                            initialValue: ''
                        })(
                            <Tabs defaultActiveKey="全部" animated={false} className={style.searchForm} onChange={this.handleChange}>
                                {tagData.map(tag => (
                                    <TabPane
                                        key={tag}
                                        tab={tag}
                                    />
                                ))}
                            </Tabs>
                        )}
                    </FormItem>
                </Form>
            </div>
        );
    }
}

export default (Form.create({})(SearchForm));



// WEBPACK FOOTER //
// ./src/components/regulatoryStatistical/index/riskHint/announcement/SearchForm.jsx